<template>
  <div id="downlink-modal">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">設定：{{ device.uid }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="送信間隔"
                  :value="uplinkInterval"
                  :items="options.uplinkInterval"
                  @change="$emit('update', ['uplinkInterval', $event])"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="ダウンリンク間隔"
                  :value="downlinkInterval"
                  :items="options.downlinkInterval"
                  @change="$emit('update', ['downlinkInterval', $event])"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="測定モード"
                  :value="mode"
                  :items="options.mode"
                  item-text="text"
                  item-value="value"
                  disabled
                ></v-select>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <channel-checkbox-group
                  :label="'測定対象CH'"
                  :channel="channel"
                  @change="$emit('update', ['channel', $event])"
                ></channel-checkbox-group>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-select
                  label="フィルタ設定"
                  :value="filter"
                  :items="options.filter"
                  @change="$emit('update', ['filter', $event])"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-select
                  label="測定レート設定"
                  :value="rate"
                  :items="options.rate"
                  @change="$emit('update', ['rate', $event])"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-select
                  label="ゲイン設定"
                  :value="gain"
                  :items="options.gain"
                  @change="$emit('update', ['gain', $event])"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <temperature-correction-form
                v-if="$store.getters['user/isSystem']"
                :enabled="temperatureCorrection.enabled"
                :a="temperatureCorrection.a"
                :b="temperatureCorrection.b"
                :c="temperatureCorrection.c"
                :d="temperatureCorrection.d"
                @update="$emit('update-correction', $event)"
              ></temperature-correction-form>
              <DeviceCorrectionForm
                :gain="device.gain"
                :offset="device.offset"
                @update="deviceParams = $event"
              />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('close')" text>閉じる</v-btn>
          <v-btn @click="$emit('submit', deviceParams)" text>更新する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChannelCheckboxGroup from "@/components/ChannelCheckboxGroup.vue";
import TemperatureCorrectionForm from "@/components/TemperatureCorrectionForm.vue";
import DeviceCorrectionForm from "@/components/DeviceCorrectionForm";

export default {
  name: "DownlinkModal",
  components: {
    ChannelCheckboxGroup,
    TemperatureCorrectionForm,
    DeviceCorrectionForm,
  },
  props: {
    dialog: { Type: Boolean, default: () => false },
    uplinkInterval: { Type: Number, default: () => null },
    downlinkInterval: { Type: Number, default: () => null },
    channel: { Type: Number, default: () => null },
    filter: { Type: Number, default: () => null },
    rate: { Type: Number, default: () => null },
    gain: { Type: Number, default: () => null },
    mode: { Type: Number, default: () => null },
    temperatureCorrection: { type: Object, default: () => null },
    device: { type: Object, default: () => null },
  },
  data() {
    return {
      options: {
        uplinkInterval: [
          { text: "定時送信なし", value: 0 },
          { text: "1分", value: 2 },
          { text: "3分", value: 4 },
          { text: "5分", value: 5 },
          { text: "15分", value: 6 },
          { text: "30分", value: 7 },
          { text: "60分", value: 8 },
          { text: "90分", value: 9 },
          { text: "120分", value: 10 },
          { text: "180分", value: 11 },
          { text: "240分", value: 12 },
          { text: "360分", value: 13 },
          { text: "720分", value: 14 },
          { text: "1440分", value: 15 },
        ],
        downlinkInterval: [
          { text: "24時間", value: 0 },
          { text: "12時間", value: 1 },
          { text: "6時間", value: 2 },
          { text: "7日", value: 3 },
        ],
        channel: [
          { text: "ch1", value: 1 },
          { text: "ch2", value: 2 },
          { text: "ch3", value: 4 },
          { text: "ch4", value: 8 },
        ],
        filter: [
          { text: "sinc4", value: 0 },
          { text: "sinc3", value: 1 },
          { text: "sinc4 + setting", value: 2 },
          { text: "sinc3 + setting", value: 3 },
        ],
        rate: [
          { text: "FS設定: 0x004 4ch: 300   1ch: 4800", value: 0 },
          { text: "FS設定: 0x006 4ch: 200   1ch: 3200", value: 1 },
          { text: "FS設定: 0x008 4ch: 150   1ch: 2400", value: 2 },
          { text: "FS設定: 0x00A 4ch: 120   1ch: 1920", value: 3 },
          { text: "FS設定: 0x00C 4ch: 100   1ch: 1600", value: 4 },
          { text: "FS設定: 0x00F 4ch: 80    1ch: 1280", value: 5 },
          { text: "FS設定: 0x014 4ch: 60    1ch: 960", value: 6 },
          { text: "FS設定: 0x018 4ch: 50    1ch: 800", value: 7 },
          { text: "FS設定: 0x01E 4ch: 40    1ch: 640", value: 8 },
          { text: "FS設定: 0x028 4ch: 30    1ch: 480", value: 9 },
          { text: "FS設定: 0x030 4ch: 25    1ch: 400", value: 10 },
          { text: "FS設定: 0x060 4ch: 12.5  1ch: 200", value: 11 },
          { text: "FS設定: 0x0C0 4ch: 6.25  1ch: 100", value: 12 },
          { text: "FS設定: 0x140 4ch: 3.75  1ch: 60", value: 13 },
          { text: "FS設定: 0x180 4ch: 3.125 1ch: 50", value: 14 },
        ],
        gain: [
          { text: "1", value: 0 },
          { text: "2", value: 1 },
          { text: "4", value: 2 },
          { text: "8", value: 3 },
          { text: "16", value: 4 },
          { text: "32", value: 5 },
          { text: "64", value: 6 },
          { text: "128", value: 7 },
        ],
        mode: [
          { text: "ひずみ4ch, Full", value: 0 },
          { text: "ひずみ4ch, Low", value: 1 },
          { text: "ひずみ3ch, 熱電対1ch", value: 2 },
          { text: "ひずみ2ch, 熱電対2ch", value: 3 },
          { text: "熱電対4ch", value: 7 },
        ],
      },
      deviceParams: null,
    };
  },
};
</script>

<style></style>
